import React from 'react';
import PropTypes from 'prop-types';

import { DetailCell, ExtraIcon } from './styled';

const VehicleLifgateIcon = ({ has_lifgate, ...props }) => (
  <DetailCell {...props}>{!!has_lifgate && <ExtraIcon name="lift-truck" />}</DetailCell>
);

VehicleLifgateIcon.propTypes = {
  has_lifgate: PropTypes.bool,
};

export default VehicleLifgateIcon;
